import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, YtKontrolaEmail, NotificationService } from 'yt-ng-framework';
import { CompanyEmail } from './company-email';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-company-email-update',
  templateUrl: './company-email-update.component.html'
})
export class CompanyEmailUpdateComponent extends BaseUpdateComponent<CompanyEmail> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }
  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'COMPANYEMAIL.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(50), 'maxlength', 'COMPANYEMAIL.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Opis", Validators.maxLength(100), 'maxlength', 'COMPANYEMAIL.OPIS.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("SvojinaID", Validators.required, 'required', 'COMPANYEMAIL.SVOJINA.VALIDATION.REQUIRED');
    
    this.baseFormGroup.setValidators(EmailKontrola('Naziv'));
    this.baseFormGroup.updateValueAndValidity();

  }

}

function EmailKontrola(emailKey:string){
  return (group: FormGroup): {[key : string]: any} =>{
    let email : string = group.controls[emailKey].value;
    let emailProvera : boolean = YtKontrolaEmail(email);
    if (emailProvera == false)
      return { checkEmail :{valid:false, message: 'COMPANYEMAIL.NAZIV.VALIDATION.PATTERN'}};
    else
      return null;
  }
}
